import {
    createStyles,
    makeStyles,
    Tooltip,
    InputLabel,
} from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";
import styled from "styled-components";

import { InfoIcon } from "../../assets/icons";
import { RelodeTheme } from "../styles";

const useStyles = makeStyles<RelodeTheme, LabelProps>(
    () =>
        createStyles({
            root: {
                position: "relative",
                display: "inline-flex",
                verticalAlign: "top",
                flexDirection: props => (props.inline ? "row" : "column"),
                justifyContent: props =>
                    props.inline ? "space-between" : "unset",
                width: props => (props.fullWidth ? "100%" : "fit-content"),
            },
            label: {
                paddingBottom: props =>
                    props.label === undefined ? 0 : props.forInput ? 4 : 10,
                paddingTop: 0,
                //height: props => (props.label === undefined ? 0 : "unset"),
            },
            content: {
                paddingTop: 6,
            },
            forInput: { paddingBottom: 10 },
        }),
    { name: "Label" }
);

export interface LabelProps {
    label: string;
    id?: string;
    children?: React.ReactElement;
    className?: string;
    tooltip?: string;
    fullWidth?: boolean;
    inline?: boolean;
    forInput?: boolean;
    error?: boolean;
    tooltipPlacement?:
        | "bottom-end"
        | "bottom-start"
        | "bottom"
        | "left-end"
        | "left-start"
        | "left"
        | "right-end"
        | "right-start"
        | "right"
        | "top-end"
        | "top-start"
        | "top";
}

export const Label = React.forwardRef((props: LabelProps, ref?: any) => {
    const {
        label,
        children,
        className: classNameProp,
        id,
        tooltip,
        tooltipPlacement,
        fullWidth,
        inline,
        forInput,
        error,
        ...others
    } = props;
    const classes = useStyles(props);

    return (
        <div className={classnames(classNameProp, classes.root)} ref={ref}>
            {tooltip ? (
                <Tooltip placement={tooltipPlacement} title={tooltip}>
                    <InputLabel
                        {...others}
                        error={error}
                        variant="standard"
                        shrink={true}
                        className={classes.label}
                    >
                        {label} <InfoIcon fontSize="inherit" />
                    </InputLabel>
                </Tooltip>
            ) : (
                <InputLabel
                    {...others}
                    error={error}
                    variant="standard"
                    shrink={true}
                    className={classes.label}
                >
                    {label}
                </InputLabel>
            )}
            {children}
        </div>
    );
});
